import { lazy, StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import "./tokens.css";
import "./workspace.css";
import { App } from "./App.tsx";
import { LegalPage, legalDocFromPath } from "./legal.tsx";

/**
 * 两套界面,按路径分流:
 *   /          租户界面(销售 / 管理者)
 *   /platform  平台后台(跨租户运营,独立令牌、独立会话)
 *   /terms /privacy  用户协议与隐私政策(公开,不经过登录 —— 登录页要求先读它们)
 *
 * **刻意不做成"同一个应用里切个视图"** —— 平台身份和租户身份是两套东西,
 * 混在一个应用里,迟早会出现"我已经登录了所以顺手让他看看"的代码。
 * nginx 的 try_files 已经把两条路径都交给这个 index.html,所以这里判一下就够了。
 */
const isPlatform = window.location.pathname.startsWith("/platform");
/** 平台后台按需加载:租户界面的人用不到它,不该把它(和提示词编辑器)算进首屏的包。 */
const PlatformApp = lazy(() => import("./platform/PlatformApp.tsx").then((module) => ({ default: module.PlatformApp })));
const legalDoc = legalDocFromPath(window.location.pathname);

createRoot(document.getElementById("root")!).render(
  <StrictMode>{legalDoc ? <LegalPage doc={legalDoc} /> : isPlatform
    ? <Suspense fallback={<div style={{ padding: 24 }} className="muted">加载中…</div>}><PlatformApp /></Suspense>
    : <App />}</StrictMode>,
);
